import { Component, Input, OnInit } from '@angular/core';
import { saveAs } from 'file-saver-es';
import { TranslateService } from '@ngx-translate/core';
import { BannerNotificationsService } from '../../../../xform-compat';
import { Attachment } from '../../../models';
import { CompanyAttachmentsService } from '../../../../core/data-services/company';
import { RmsUtilsService } from '../../../../core/services';


/**
 * Component class for text content attachments
 */
@Component({
    selector: 'rms-text-content-attachments',
    templateUrl: './text-content-attachments.component.html',
    styleUrls: ['./text-content-attachments.component.scss'],
    standalone: false
})
export class TextContentAttachmentsComponent implements OnInit {

  @Input() attachments: Array<Attachment>;
  public isOpen = false;

  constructor(
    private attachmentsService: CompanyAttachmentsService,
    private bannerNotificationService: BannerNotificationsService,
    private translateService: TranslateService,
    private utilsService: RmsUtilsService
  ) { }

  ngOnInit() {
    this.attachments.map(item => this.utilsService.setIconType(item));
  }

  /**
   * Download the physical file
   * @param file
   */
  public downloadFile (file: Attachment) {
    if ( RmsUtilsService.userAgentIOS() ) {
      this.bannerNotificationService.error(this.translateService.instant('GENERICS.IPHONE_RESTRICTION'));
      return;
    }
    this.attachmentsService.downloadFile(file).subscribe(
      value => saveAs(value, file.fileName),
      error1 => this.bannerNotificationService.error(error1)
    );
  }

}
